import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import { menuShape } from 'utils/shapes/menuOptionsShapes';
import { classesShape } from 'utils/shapes/classesShape';
import DropdownMenu from 'components/DropdownMenu';
import SectionTitle from 'components/SectionTitle';

import { Button } from '@material-ui/core';
import styles from './Section.styles';

const Section = ({
  children,
  classes,
  marginTop,
  marginBottom,
  title,
  menuOptions,
  isDropdownMenu,
  onChange,
  largeMarginBottom,
  primaryHoverButton,
  buttons,
}) => (
  <>
    <div
      className={
        classNames(classes.titleWrapper, {
          [classes.title]: marginBottom,
          [classes.marginTop]: marginTop,
          [classes.largeMarginBottom]: largeMarginBottom,
        })
      }
    >
      <SectionTitle>
        {title}
      </SectionTitle>
      <div className={classes.actionsWrapper}>
        {buttons.map((button) => (
          <Button
            key={button.text}
            variant={button.variant}
            color={button.color}
            endIcon={button.endIcon}
            startIcon={button.startIcon}
            onClick={button.onClick}
          >
            {button.text}
          </Button>
        ))}
        {isDropdownMenu && (
        <DropdownMenu
          options={menuOptions}
          onChange={onChange}
          primaryHoverButton={primaryHoverButton}
        />
        )}
      </div>
    </div>
    {children}
  </>
);

Section.propTypes = {
  title: PropTypes.node.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string,
    endIcon: PropTypes.node,
    variant: PropTypes.string,
    onClick: PropTypes.func,
    startIcon: PropTypes.node,
  })),
  children: PropTypes.node,
  classes: classesShape,
  isDropdownMenu: PropTypes.bool,
  largeMarginBottom: PropTypes.bool,
  marginBottom: PropTypes.bool,
  marginTop: PropTypes.bool,
  menuOptions: PropTypes.arrayOf(menuShape),
  primaryHoverButton: PropTypes.bool,
  onChange: PropTypes.func,
};

Section.defaultProps = {
  classes: {},
  marginTop: false,
  marginBottom: true,
  children: null,
  menuOptions: [],
  isDropdownMenu: false,
  onChange: () => {},
  largeMarginBottom: false,
  primaryHoverButton: false,
  buttons: [],
};

export default withStyles(styles)(Section);
